/// <reference path="../../../tools/typings/angularjs/angular.d.ts"/>

module DealerwareWebContent {

    "use strict";

    // Probably the way Blayne would've done this is to fit it into some huge
    // structure with delegates etc.  We can go there later but for now, I'm just
    // trying to handle the simple errors e.g. unauthorized error from routing.js
    // which was accusatory and not helpful.
    //
    export class ErrorPageController {

        public static $inject : string[ ] = [

        ];

        constructor(
        ) {

        }
    }

    getDealerwareWebContentModule().controller(
        'ErrorPageController', ErrorPageController
    );
}
